<template>
  <div class="base-bg" v-if="visible">
    <TopBar
      :title="$t('moduleTitles.basicInfo')"
      @onClickClose="close"
      @onClickSave="handleSubmit"
    ></TopBar>
    <div class="set-content">
      <MediaSelect
        :url="form.thumb_path"
        :title="$t('enum.covers.0')"
        :btnTitle="$t('actionTitles.changeCover')"
        @changeMedia="changeMedia"
        @deleteMedia="deleteMedia"
        size="450 x 450"
      ></MediaSelect>

      <a-form-model
        layout="vertical"
        ref="ruleForm"
        :form="form"
        :rules="rules"
        :model="form"
      >
        <div class="options-item">
          <a-form-model-item
            has-feedback
            style="color: #ffffff"
            :label="$t('publish.workName.label')"
          >
            <a-input
              style="
                backgroundcolor: #333 !important;
                border: 1px solid #555;
                color: #fff;
              "
              v-model="form.name"
            />
          </a-form-model-item>
        </div>
        <a-form-model-item has-feedback :label="$t('publish.pDescription')">
          <!-- <a-textarea
            v-model="form.brief"
            :placeholder="$t('publish.desPlaceholder')"
            allow-clear
            :row="4"
            :auto-size="{ minRows: 5, maxRows: 5 }"
            class="intro-textarea"
          /> -->
          <editor :value="form.brief" @changeEditor="changeEditor"></editor>
        </a-form-model-item>
        <div style="display: flex; justify-content:space-between;">
          <a-form-model-item has-feedback :label="$t('publish.isPublic')">
            <a-radio-group v-model="form.is_public">
              <a-radio :value="1">{{ $t("publish.public") }}</a-radio>
              <a-radio :value="0">{{ $t("publish.pravite") }}</a-radio>
            </a-radio-group>
          </a-form-model-item>
          <a-form-model-item has-feedback :label="'顯示浮水印'">
            <a-radio-group v-model="form.is_water" >
              <a-radio :value="1">是</a-radio>
              <a-radio :value="0">否</a-radio>
            </a-radio-group>
          </a-form-model-item>
        </div>
        <CateTreeSelect v-model="form.cate"></CateTreeSelect>
        <div class="options-item">
          <a-form-item>
            <CTagSelect
              :isPc="false"
              :defaultValue="form.tag"
              @updateTagData="updateTagData"
            ></CTagSelect>
          </a-form-item>
        </div>

        <!-- <div class="options-item"> -->
        <a-form-item :label="$t('publish.workRegion.label')">
          <HRegionSelect
            :defaultValue="form.parent_region"
            @regionData="getRegionData"
          ></HRegionSelect>
        </a-form-item>
        <div class="options-item">
            <a-form-model-item :label="$t('publish.address.label')">
            <a-input 
                :placeholder="$t('publish.address.placeholder')"
                v-model="form.detail_address"
            />
            </a-form-model-item>
        </div>
        <div class="options-item">
            <a-row>
                <a-col :span="10">
                    <a-form-model-item :label="$t('publish.customerName.label')">
                        <a-input :placeholder="$t('publish.customerName.placeholder')"
                                    v-model="form.customer_name" />
                    </a-form-model-item>
                </a-col>
                <a-col :span="4">
                </a-col>
                <a-col :span="10">
                    <a-form-model-item :label="$t('publish.customerTel.label')">
                        <a-input :placeholder="$t('publish.customerTel.placeholder')"
                                    v-model="form.customer_phone" />
                    </a-form-model-item>
                </a-col>
            </a-row>
        </div>
        <!-- </div> -->
      </a-form-model>
    </div>
  </div>
</template>

<script>
import TopBar from "./TopBar.vue";
// import MaterialSelect from "@/components/MaterialSelect";
import MediaSelect from "./MediaSelect.vue";
import HRegionSelect from "@/components/HRegionSelect";
import CTagSelect from "@/components/Tag";
import { mapGetters } from "vuex";
import CateTreeSelect from "@/components/CateTreeSelect";

import { getTree as getCateTree } from "@/api/cate";
import Editor from "@/components/Editor";

export default {
  components: {
    TopBar,
    MediaSelect,
    HRegionSelect,
    CTagSelect,
    CateTreeSelect,
    Editor
  },
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      form: {
        uid: null,
        name: "",
        thumb_path:
          "http://qiniu.vipyun.vip/1812/works/7510212bb95f1259/thumb.jpg",
        brief: "",
        is_public: 1,
        is_water: 0,
        cate: null,
        tag: [],
        region: null,
        parent_region: [],
        detail_address: "",
        customer_name: "",
        customer_phone: "",
      },
      rules: {},
      cateTree: [],
    };
  },
  computed: { ...mapGetters(["vrbase"]) },
  created() {
    this.form = this.$deepClone(this.vrbase.base);
    console.log(this.form);
    //獲取分類
    getCateTree().then((res) => {
      this.cateTree = res.data;
    });
  },
  methods: {
    show() {
      this.isShow = true;
    },
    close() {
      this.$emit("close");
    },
    changeMedia(value) {
      this.form.thumb_path = value.url;
    },
    deleteMedia() {
      this.form.thumb_path = "";
    },
    // =======
    updateTagData(data) {
      this.form.tag = data;
      console.log(this.form);
    },
    handleSelectedLandmark(value) {
      this.form.thumb_path = value.url;
      console.log(value);
    },
    cateSelected(data) {
      console.log("cateSelected==", data);
      this.form.cate = data.id;
    },
    getRegionData(data) {
      this.form.region = data;
    },
    handleSubmit() {
      // e.preventDefault();
      if (!this.form.name) {
        this.$message.error(this.$t("form.work.field.name.placeholder"));
        return;
      }
      this.$refs.ruleForm.validate((valid) => {
        if (valid) {
          console.log("===result==", {
            ...this.vrbase,
            base: this.form,
          });
          const vrbase = { ...this.vrbase, base: this.form };
          this.$store
            .dispatch("saveVRBase", { vrbase, showLoading: true })
            .then(() => {
              // this.$message.success(this.$t("message.saveSuccess"));
              this.$emit("close");
            });
        }
      });
    },
    changeEditor(content) {
      this.form.brief = content;
    },
  },
};
</script>

<style lang="less" scoped>
.base-bg {
  /deep/ .ant-input,
  /deep/ .ant-select-selection,
  /deep/ .ant-input-number-input {
    background-color: #333 !important;
    border: 1px solid #555;
    color: #fff;
  }
  /deep/ .ant-cascader-picker {
    color: #fff;
  }

  /deep/ .ant-form-item-label > label {
    color: #fff !important;
  }

  /deep/ span + * {
    color: #fff;
  }
  ::v-deep .ql-container,::v-deep .ql-editor{
  height: 300px;
}
}
</style>
<style lang="less">
.intro-textarea {
  .ant-input-textarea-clear-icon {
    font-size: 14px;
    color: rgba(255, 255, 255, 0.3);
    margin-right: 12px;
    &:hover {
      color: rgba(255, 255, 255, 0.4);
    }
  }
}
</style>
